import type { AgentDayOneReport } from '../types';

/** The stored report text as paragraphs (split on blank lines). Line breaks and indents inside a
 *  paragraph are kept, so render each one with `white-space: pre-wrap`. */
export function reportParagraphs(body: string): string[] {
  return body
    .replace(/\r\n/g, '\n')
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.replace(/^\n+/, '').trimEnd())
    .filter((paragraph) => paragraph.trim().length > 0);
}

/** What the card shows when the report has no top items (the all-clear report): its first paragraph. */
export function cardSummary(report: Pick<AgentDayOneReport, 'body' | 'topItems'>): string | null {
  if (report.topItems.length > 0) return null;
  return reportParagraphs(report.body)[0] ?? null;
}

/** "Sep 23, 2026". `locale`/`timeZone` exist for tests; the UI passes neither. */
export function formatReportDate(createdAt: number, locale?: string, timeZone?: string): string {
  if (!Number.isFinite(createdAt)) return '';
  return new Date(createdAt).toLocaleDateString(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    ...(timeZone ? { timeZone } : {}),
  });
}
